import { render, staticRenderFns } from "./Valid.vue?vue&type=template&id=40744626&scoped=true&"
import script from "./Valid.vue?vue&type=script&lang=js&"
export * from "./Valid.vue?vue&type=script&lang=js&"
import style0 from "./Valid.vue?vue&type=style&index=0&id=40744626&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40744626",
  null
  
)

export default component.exports